module.exports = "/assets/data/1fd36fbb5ee66dc7b670c655f216ffaa-NN8.data.json";